/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatbotConversationResponseDto
 */
export interface ChatbotConversationResponseDto {
    /**
     * Unique conversation ID
     * @type {string}
     * @memberof ChatbotConversationResponseDto
     */
    id: string;
    /**
     * User ID who owns the conversation
     * @type {string}
     * @memberof ChatbotConversationResponseDto
     */
    userId: string;
    /**
     * Conversation title
     * @type {string}
     * @memberof ChatbotConversationResponseDto
     */
    title?: string;
    /**
     * When the conversation was created
     * @type {Date}
     * @memberof ChatbotConversationResponseDto
     */
    createdAt: Date;
    /**
     * When the conversation was last updated
     * @type {Date}
     * @memberof ChatbotConversationResponseDto
     */
    updatedAt: Date;
    /**
     * Treatment plan ID
     * @type {string}
     * @memberof ChatbotConversationResponseDto
     */
    treatmentPlanId?: string;
    /**
     * Patient ID
     * @type {string}
     * @memberof ChatbotConversationResponseDto
     */
    patientId?: string;
}

/**
 * Check if a given object implements the ChatbotConversationResponseDto interface.
 */
export function instanceOfChatbotConversationResponseDto(value: object): value is ChatbotConversationResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ChatbotConversationResponseDtoFromJSON(json: any): ChatbotConversationResponseDto {
    return ChatbotConversationResponseDtoFromJSONTyped(json, false);
}

export function ChatbotConversationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatbotConversationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'title': json['title'] == null ? undefined : json['title'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'treatmentPlanId': json['treatmentPlanId'] == null ? undefined : json['treatmentPlanId'],
        'patientId': json['patientId'] == null ? undefined : json['patientId'],
    };
}

export function ChatbotConversationResponseDtoToJSON(json: any): ChatbotConversationResponseDto {
    return ChatbotConversationResponseDtoToJSONTyped(json, false);
}

export function ChatbotConversationResponseDtoToJSONTyped(value?: ChatbotConversationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'title': value['title'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'treatmentPlanId': value['treatmentPlanId'],
        'patientId': value['patientId'],
    };
}

